import L from 'leaflet'
import { icon as faIcon } from '@fortawesome/fontawesome-svg-core'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export function createEntityIcon(color: string, iconDef: IconDefinition, selected: boolean): L.DivIcon {
  const border = selected ? '3px solid #fff' : '2px solid rgba(0,0,0,0,0,0.35)'
  const scale = selected ? 1.08 : 1
  const markerSvg = faIcon(iconDef, {
    styles: { color: '#ffffff', width: '13px', height: '13px' },
  }).html.join('')
  const html = `<div style="transform:scale(${scale});width:30px;height:30px;border-radius:9999px;background:${color};border:${border};box-shadow:0 2px 8px rgba(0,0,0,0.35);display:flex;align-items:center;justify-content:center;">${markerSvg}</div>`
  return L.divIcon({
    className: 'control-center-map-marker',
    html,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
  })
}

export function createResultIcon(color: string, iconDef: IconDefinition, focused = false): L.DivIcon {
  const markerSvg = faIcon(iconDef, {
    styles: { color: '#ffffff', width: '12px', height: '12px' },
  }).html.join('')
  const border = focused ? '3px solid #fbbf24' : '2px solid #fff'
  const scale = focused ? '1.08' : '1'
  const html = `<div style="transform:scale(${scale});width:28px;height:28px;border-radius:8px;background:${color};border:${border};box-shadow:0 2px 8px rgba(0,0,0,0.35);display:flex;align-items:center;justify-content:center;">${markerSvg}</div>`
  return L.divIcon({
    className: 'control-center-result-marker',
    html,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  })
}

/** Invisible anchor so a popup can open without covering a coincident cluster badge. */
export function createInvisiblePopupAnchorIcon(): L.DivIcon {
  return L.divIcon({
    className: 'control-center-popup-anchor',
    html: '<div style="width:1px;height:1px;opacity:0"></div>',
    iconSize: [1, 1],
    iconAnchor: [0, 0],
  })
}

/** Numbered bubble for clustered map markers. Icons are cached by count. */
const clusterIconCache = new Map<number, L.DivIcon>()

export function createClusterIcon(count: number): L.DivIcon {
  const cached = clusterIconCache.get(count)
  if (cached) return cached
  const size = count >= 100 ? 44 : count >= 10 ? 38 : 34
  const fontSize = count >= 100 ? 12 : 13
  const html = `<div style="width:${size}px;height:${size}px;border-radius:9999px;background:#334155;border:2px solid #fff;box-shadow:0 2px 10px rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center;color:#fff;font-size:${fontSize}px;font-weight:700;line-height:1;font-family:inherit;">${count}</div>`
  const icon = L.divIcon({
    className: 'control-center-cluster-marker',
    html,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  })
  clusterIconCache.set(count, icon)
  return icon
}

